import { AppThunkAction } from '../reducers';

// Actions
import * as Actions from '../actions';

// Services
import * as service from '../../services/PractitionerConsumptionSyncProcess.Service';

// Models
import { PractitionerConsumptionSyncProcess } from '../../models/Entities/Practitioners/PractitionerConsumptionSyncProcess';
import { ErrorType } from '../../models/HttpError';

type KnownAction =
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetAllByPractitionerIdFailureAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetByIdFailureAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessGetLastByPractitionerIdFailureAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessCreateFailureAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessUpdateRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessUpdateSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessUpdateFailureAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessDeleteRequestAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessDeleteSuccessAction
    | Actions.PractitionerConsumptionSyncProcess.PractitionerConsumptionSyncProcessDeleteFailureAction;

export const ActionCreators = {
    GetAllPractitionerConsumptionSyncProcessByPractitionerId: (practitionerId: string): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                var token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_FAILURE',
                        practitionerId: practitionerId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                dispatch({
                    type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_REQUEST',
                    practitionerId: practitionerId,
                });

                if (appState) {
                    service.GetPractitionerConsumptionSyncProcesses(practitionerId, token)
                        .then((list: PractitionerConsumptionSyncProcess[]) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_SUCCESS',
                                practitionerId: practitionerId,
                                processes: list
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETALL_BYPRACTITIONERID_FAILURE',
                                practitionerId: practitionerId,
                                error: error
                            });
                        });
                }
        },
    GetPractitionerConsumptionSyncProcessById: (practitionerId: string, syncProcessId: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            var token: string = '';

            if (appState.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_FAILURE',
                    practitionerId: practitionerId,
                    syncProcessId: syncProcessId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = appState.oidc.user.access_token;
            };

            dispatch({
                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_REQUEST',
                practitionerId: practitionerId,
                syncProcessId: syncProcessId,
            });

            if (appState) {
                service.GetPractitionerConsumptionSyncProcessById(syncProcessId, token)
                    .then((process: PractitionerConsumptionSyncProcess) => {
                        dispatch({
                            type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_SUCCESS',
                            process: process
                        });
                    })
                    .catch((error: ErrorType) => {
                        dispatch({
                            type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GET_BYID_FAILURE',
                            practitionerId: practitionerId,
                            syncProcessId: syncProcessId,
                            error: error
                        });
                    }
                    );
            }
        },
    GetLastPractitionerConsumptionSyncProcessByPractitionerId: (practitionerId: string): AppThunkAction<KnownAction> =>
                (dispatch, getState) => {
                    const appState = getState();
                    var token: string = '';
    
                    if (appState.oidc?.user?.access_token === undefined) {
                        dispatch({
                            type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_FAILURE',
                            practitionerId: practitionerId,
                            error: {
                                ErrorCode: 401,
                                ErrorMessage: 'Not authorized',
                                Errors: []
                            }
                        });
                        return;
                    } else {
                        token = appState.oidc.user.access_token;
                    };
    
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_REQUEST',
                        practitionerId: practitionerId,
                    });
    
                    if (appState) {
                        service.GetLastPractitionerConsumptionSyncProcess(practitionerId, token)
                            .then((process: PractitionerConsumptionSyncProcess) => {
                                dispatch({
                                    type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_SUCCESS',
                                    practitionerId: practitionerId,
                                    process: process
                                });
                            })
                            .catch((error: ErrorType) => {
                                dispatch({
                                    type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_FAILURE',
                                    practitionerId: practitionerId,
                                    error: error
                                });
                            });
                    }
        },
    CreatePractitionerConsumptionSyncProcess: (practitionerId: string): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                var token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_FAILURE',
                        practitionerId: practitionerId,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_REQUEST',
                        practitionerId: practitionerId
                    });

                    service.AddPractitionerConsumptionSyncProcess(practitionerId, token)
                        .then((process: PractitionerConsumptionSyncProcess) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_SUCCESS',
                                process: process
                            });
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_GETLAST_BYPRACTITIONERID_SUCCESS',
                                practitionerId: practitionerId,
                                process: process
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_CREATE_FAILURE',
                                practitionerId: practitionerId,
                                error: error
                            });
                        });
                }
        },
    UpdatePractitionerConsumptionSyncProcess: (process: PractitionerConsumptionSyncProcess): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                var token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_UPDATE_FAILURE',
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_UPDATE_REQUEST',
                        process: process
                    });

                    service.UpdatePractitionerConsumptionSyncProcess(token, process)
                        .then((process: PractitionerConsumptionSyncProcess) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_UPDATE_SUCCESS',
                                process: process
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_UPDATE_FAILURE',
                                error: error
                            });
                        });
                }
        },
    DeletePractitionerConsumptionSyncProcess: (practitionerId: string, id: string): AppThunkAction<KnownAction> =>
            (dispatch, getState) => {
                const appState = getState();
                var token: string = '';

                if (appState.oidc?.user?.access_token === undefined) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_DELETE_FAILURE',
                        practitionerId: practitionerId,
                        id: id,
                        error: {
                            ErrorCode: 401,
                            ErrorMessage: 'Not authorized',
                            Errors: []
                        }
                    });
                    return;
                } else {
                    token = appState.oidc.user.access_token;
                };

                if (appState) {
                    dispatch({
                        type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_DELETE_REQUEST',
                        practitionerId: practitionerId,
                        id: id
                    });

                    service.DeletePractitionerConsumptionSyncProcess(id, token)
                        .then(() => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_DELETE_SUCCESS',
                                practitionerId: practitionerId,
                                id: id
                            });
                        })
                        .catch((error: ErrorType) => {
                            dispatch({
                                type: 'PRACTITIONERCONSUMPTIONSYNCPROCESS_DELETE_FAILURE',
                                practitionerId: practitionerId,
                                id: id,
                                error: error
                            });
                        });
                }
        }
};